import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  getClientDocuments,
  getClientDocumentsErrors,
  getClientDocumentsFetched,
  getClientDocumentsFilter,
  getClientDocumentsSearchParams,
  getShowJobDialog,
  IState,
  selectFeature,
} from './client-data.reducer';
import { EntityDataStore } from '../entity-data/entity-data.store';
import { Client } from './client.model';
import { Observable } from 'rxjs';
import { List } from 'immutable';
import { Document } from '../document-data/document.model';
import { DocumentHistoryFilterTypesEnum } from './client-data.data';
import { IError, ISearchParams } from '../entity-data/entity-data.data';

@Injectable()
export class ClientDataStore extends EntityDataStore<IState, Client> {
  constructor(store: Store<any>) {
    super(store, selectFeature);
  }

  getClientDocuments(): Observable<List<Document>> {
    return this.store.select(getClientDocuments());
  }

  getClientDocumentsFetched(): Observable<boolean> {
    return this.store.select(getClientDocumentsFetched());
  }

  getClientDocumentsSearchParams(): Observable<ISearchParams> {
    return this.store.select(getClientDocumentsSearchParams());
  }

  getClientDocumentsFilter(): Observable<DocumentHistoryFilterTypesEnum> {
    return this.store.select(getClientDocumentsFilter());
  }

  getClientDocumentsErrors(): Observable<IError> {
    return this.store.select(getClientDocumentsErrors());
  }

  getShowJobDialog(): Observable<boolean> {
    return this.store.select(getShowJobDialog());
  }
}
